jQuery(document).ready(function () { 

    /* header starts below announcement bar; tracks it off-screen, then locks at top:0 */
    var annH = 38;
    var headerH = jQuery('.header-sticky-wrapper').outerHeight() || 80;
    //document.documentElement.style.setProperty('--rfr-header-h', headerH + 'px');

    var scrollTicking = false;
    function handleScrollEffects() {
      var scrollY = jQuery(window).scrollTop();
      document.documentElement.style.setProperty('--rfr-ann-h', Math.max(0, annH - scrollY) + 'px');
      jQuery('.header-sticky-wrapper').toggleClass("rfr-stick", scrollY > annH + 50);

      /* pdp sticky atc for responsive devices */
      if($(window).width() <= 768){
        var windheight1 = scrollY;
        var swatchElement = jQuery('.product-section');
        if (swatchElement.length) {
          var swatch1 = swatchElement.offset().top + 50;
          if (windheight1 > swatch1) {
            $('.product-block.atcwrap').addClass("rfrmbst");
          } else {
            $('.product-block.atcwrap').removeClass("rfrmbst");
          }
        }
      }
    }

    $(window).on('scroll', function() {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function() {
        handleScrollEffects();
        scrollTicking = false;
      });
    });

    handleScrollEffects();

    // /* slick slider like bsellr, home others */
    //         dots: true,
    //         slidesToShow: 2,
    //         slidesToScroll: 2,
    //       },
    //     },
    //   ],
    // });

    // /* review slick slider home */
    // $(".review-slider.sld").slick({
    //   mobileFirst: true,
    //   adaptiveHeight: true,
    //   vertical: false,
    //   infinite: false,
    //   arrows: true,
    //   dots: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   responsive: [
    //     {
    //       breakpoint: 1599,
    //       settings: {
    //         arrows: true,
    //         dots: false,
    //         slidesToShow: 3.4,
    //         slidesToScroll: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 1350,
    //       settings: {
    //         arrows: true,
    //         dots: false,
    //         slidesToShow: 3.4,
    //         slidesToScroll: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         arrows: true,
    //         dots: true,
    //         slidesToShow: 3.4,
    //         slidesToScroll: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 991,
    //       settings: {
    //         arrows: true,
    //         dots: true,
    //         slidesToShow: 3,
    //         slidesToScroll: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 767,
    //       settings: {
    //         arrows: true,
    //         dots: true,
    //         slidesToShow: 2,
    //         slidesToScroll: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 320,
    //       settings: {
    //         arrows: true,
    //         dots: true,
    //         slidesToShow: 1.2,
    //         slidesToScroll: 1,
    //       },
    //     },
    //   ],
    // });

    // /* new shop by catagory slick slider home */
    // $(".shopsl-bx").slick({
    //   infinite: true,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   arrows: true,
    //   dots: true,  
    // });

    // /* bank promotion discount slick slider home */
    // $(".rbanks-bx").slick({
    //   infinite: true,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //   speed: 500,  
    //   arrows: false,
    //   dots: true,  
    // });

    /* Initialize the Slick sliders on document ready */
    //initSlickSlider();
    //tabAgeSlider();
    //collCatSlickSlider();
    //initTwoRowSlider();
    //momUnstoppableUsbSlider();
    //knowBaseCatSlider();

    /* re-run the function on window resize to ensure responsiveness */
    // $(window).resize(function() {
    //   //initSlickSlider();
    //   //tabAgeSlider();
    //   //collCatSlickSlider();
    //   // initTwoRowSlider();
    //   // momUnstoppableUsbSlider();
    //   // knowBaseCatSlider();
    // });

    /* old shop by category slick slider home */
    // function initSlickSlider() {
    //   if ($(window).width() <= 768) {
    //     // Check if Slick is already initialized
    //     if (!$('.shop-bx').hasClass('slick-initialized')) {
    //       $('.shop-bx').slick({
    //         slidesToShow: 3,      // Show 2 items per row
    //         slidesToScroll: 2,    // Scroll 2 items at a time
    //         rows: 2,              // Display 2 rows in a single slide
    //         dots: false,           // Show dots for navigation
    //         arrows: false,        // Hide arrows for mobile
    //         autoplay: false,       // Enable auto-play
    //         infinite: false,
    //         responsive: [
    //           {
    //             breakpoint: 768,  // Apply Slick slider only for screens <= 768px
    //             settings: {
    //               slidesToShow: 3.5,
    //               slidesToScroll: 2,
    //               rows: 2
    //             }
    //           }
    //         ]
    //       });
    //     }
    //   } else {
    //     // Destroy Slick slider if the screen size is greater than 768px
    //     if ($('.shop-bx').hasClass('slick-initialized')) {
    //       $('.shop-bx').slick('unslick');
    //     }
    //   }
    // }

    /* old shop by age slick slider home */
    // function tabAgeSlider() {
    //   if ($(window).width() <= 768) {
    //     if (!$('.tab-con').hasClass('slick-initialized')) {
    //       $(".tab-con").slick({
    //         mobileFirst: true,
    //         adaptiveHeight: true,
    //         vertical: false,
    //         infinite: false,
    //         slidesToShow: 1.5,
    //         slidesToScroll: 1,
    //         arrows: false,
    //         dots: false,
    //         autoplay: false,
    //         responsive: [
    //           {
    //             breakpoint: 768,  // Apply Slick slider only for screens <= 768px
    //             settings: {
    //               slidesToShow: 1.5,
    //               slidesToScroll: 1
    //             }
    //           }
    //         ]
    //       });
    //     }
    //   } else {
    //     // Destroy Slick slider if the screen size is greater than 768px
    //     if ($('.tab-con').hasClass('slick-initialized')) {
    //       $('.tab-con').slick('unslick');
    //     }
    //   }
    // }


    /* old shop by age change tab class and display content home */
    jQuery('.tabs-nav a').on('click', function (event) {
        event.preventDefault();
        jQuery('.tab-active').removeClass('tab-active');
        jQuery(this).parent().addClass('tab-active');
        jQuery('.tabs-stage .tab-con').hide();
        jQuery(jQuery(this).attr('href')).show();
      
        if ($(window).width() <= 768) {
          let tabId = jQuery(this).attr('href');
          //jQuery(tabId).slick('setPosition');
        }
    });
    jQuery('.tabs-nav a:first').trigger('click');

    /* accordion for responsive devices footer */
    if($(window).width() <= 767){
        //jQuery('.rffoot-sec:first-child').addClass("ropen");
        jQuery('.rffoot-sec').click(function () {
            if(!jQuery(this).hasClass("ropen")){
                jQuery('.rffoot-sec').removeClass("ropen");
                jQuery(this).addClass('ropen');
            }else{
                jQuery(this).removeClass("ropen");
            }  
        });
    }

    /* faq accordion pdp */
    jQuery('.faq label').click(function () {
        if(!jQuery(this).hasClass("fqopn")){
            jQuery('.faq label').removeClass("fqopn");
            jQuery(this).addClass('fqopn');
        }else{
            jQuery(this).removeClass("fqopn");
        }  
    });

    /* == start */
    $('.readl-desk').click(function () {
        $('.cont-ul').addClass("desk-cls")
        $('.cont-ul').removeClass("desk-opn");
    });

    $('.readm-desk').click(function () {
        if(!$('.cont-ul').hasClass("desk-cls")){
          if(!$('.cont-ul').hasClass("desk-opn")){
              $('.cont-ul').addClass("desk-opn")
          }else{;
              $('.cont-ul').removeClass("desk-opn")
          }
        }else{
          $('.cont-ul').removeClass("desk-cls");
        }  
    });

    $('.readl-mob').click(function () {
        $('.conttwbx').addClass("mob-cls")
        $('.conttwbx').removeClass("mob-opn");
    });

    $('.readm-mob').click(function () {
        if(!$('.conttwbx').hasClass("mob-cls")){
          if(!$('.conttwbx').hasClass("mob-opn")){
              $('.conttwbx').addClass("mob-opn")
          }else{
              $('.conttwbx').removeClass("mob-opn")
          }
        }else{
          $('.conttwbx').removeClass("mob-cls");
        }  
    });
    /* == end */

    /* share block pdp start */
    $('.product-block.rfr-share').click(function () {
        if($('.product-block.rfr-share .popuptext').hasClass("show-social")){
            $('body').addClass("opnsoc")
        }else{
            $('body').removeClass("opnsoc")
        }
    });

    $('.product-block.rfr-share-tp').click(function () {
        if($('.product-block.rfr-share .popuptext').hasClass("show-social")){
            $('body').addClass("opnsoc")
        }else{
            $('body').removeClass("opnsoc")
        }
    });
    /* share block pdp end */

    /* offer block pdp */
    $('.ofr-tw .ofr-cpn').click(function () {
        $(this).addClass("copied");
        var $temp = $("<textarea>");
        $("body").append($temp);
        $temp.val($(this).find(".ofr-txt").text()).select();
        document.execCommand("copy");
        $temp.remove();
        setTimeout(function() {
            $('.ofr-tw .ofr-cpn').removeClass("copied");
        }, 800);  
    });
  
    /* == start */
    // function collCatSlickSlider() {
    //   if ($(window).width() <= 768) {
    //     // Check if Slick is already initialized
    //     if (!$('.cat-bx').hasClass('slick-initialized')) {
    //       $('.cat-bx').slick({
    //         mobileFirst: true,
    //         adaptiveHeight: true,
    //         vertical: false,
    //         infinite: false,
    //         slidesToShow: 4,      // Show 2 items per row
    //         slidesToScroll: 1,    // Scroll 2 items at a time
    //         dots: false,           // Show dots for navigation
    //         arrows: true,        // Hide arrows for mobile
    //         autoplay: false,       // Enable auto-play
    //         responsive: [
    //           {
    //             breakpoint: 768,  // Apply Slick slider only for screens <= 768px
    //             settings: {
    //               slidesToShow: 4,
    //               slidesToScroll: 4
    //             }
    //           }
    //         ]
    //       });
    //     }
    //   } else {
    //     // Destroy Slick slider if the screen size is greater than 768px
    //     if ($('.cat-bx').hasClass('slick-initialized')) {
    //       $('.cat-bx').slick('unslick');
    //     }
    //   }
    // }
    /* == end */

    /* list out of stck product last collection start */
    // Find the <li> elements with the class "out of stock"
    var outOfStockItems = $('.grid__item.grid-product.out-of-stock');
    // Move the out-of-stock items to the end of the parent container
    outOfStockItems.appendTo(outOfStockItems.parent());
    var targetClass = ".grid-product";
    function isMobileWidth() {
      return $(window).width() <= 768; // Adjust the breakpoint as needed
    }
    // Loop through each element with the target class
    $(targetClass).each(function() {
      var firstPosition = isMobileWidth() ? $(this).data("mobile-position") : $(this).data("first-position");
      // Move the <li> element to the desired position
      if (firstPosition > 0 && firstPosition <= $(targetClass).length) {
        $(this).insertAfter($(targetClass).eq(firstPosition));
      }
    });
    /* list out of stck product last collection end */

    /* offer slick slider pdp */
    // $(".ofr-sld").slick({
    //   infinite: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   dots: true,  
    //   responsive: [
    //     {
    //       breakpoint: 768,  // Apply Slick slider only for screens <= 768px
    //       settings: {
    //         dots: false,
    //         slidesToShow: 1.2
    //       }
    //     }
    //   ]
    // });

    /* size guide block pdp start */
    var sizeChartBtn = $('.page-content--product').find("[data-open-size-chart-popup]");
    sizeChartBtn.on("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
    
        document.body.classList.add("size-chart-show");
        $("#MainContent .halo-size-chart-popup").addClass("is-show");
    });
    
    $(document).on("click", "[data-close-size-chart-popup]", () => {
        $('body').removeClass("size-chart-show");
        $(".halo-size-chart-popup").removeClass("is-show");
    });
    
    $(document).on("click", (event) => {
        if ($('body').hasClass("size-chart-show")) {
            if (
                $(event.target).closest("[data-open-size-chart-popup]").length ===
                0 &&
                $(event.target).closest("[data-size-chart-popup]").length === 0
            ) {
                $('body').removeClass("size-chart-show");
            }
        }
    });
    /* size guide block pdp end */

    /* == start */
    
    /* == end */

    /* back to history btn cart */
    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('cart-bck-mob')) {
        window.history.back();
      }
    });

    /* article page/blog post slick slider */
    var productGrid = $("[data-product-slider-article]"),
      itemToShow = productGrid.data("item-to-show"),
      itemDots = productGrid.data("item-dots"),
      itemArrows = productGrid.data("item-arrows"),
      itemRows = productGrid.data("item-rows");

    // if (productGrid.length > 0) {
    //   if (productGrid.not(".slick-initialized")) {
    //     productGrid.slick({
    //       adaptiveHeight: true,
    //       vertical: false,
    //       infinite: false,
    //       slidesToShow: itemToShow,
    //       slidesToScroll: 1,
    //       rows: itemRows, 
    //       arrows: itemArrows,
    //       dots: itemDots,
    //       responsive: [
    //         {
    //           breakpoint: 1024,
    //           settings: {
    //             arrows: true,
    //             dots: false,
    //             slidesToShow: 3,
    //             slidesToScroll: 1,
    //           },
    //         },
    //         {
    //           breakpoint: 767,
    //           settings: {
    //             arrows: true,
    //             dots: true,
    //             slidesToShow: 2,
    //             slidesToScroll: 1,
    //           },
    //         },
    //         {
    //           breakpoint: 320,
    //           settings: {
    //             arrows: true,
    //             dots: true,
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //           },
    //         }, 
    //       ],
    //     });
    //   }
    // }

    /* zipcode validation cart start */
    let cartAllZipcode = document.querySelectorAll(".cart-input-zipcode");
    if(cartAllZipcode) {
      cartAllZipcode.forEach((cartInputZipcode, index) => {
        let cartZipcodeError = document.querySelectorAll(".cart-zipcode-error")[index];
        //let cartZipcodeSuccess = document.querySelectorAll(".cart-zipcode-success")[index];
        let cartCheckZipcodeBtn = document.querySelectorAll(".cart-check-zipcode")[index];
        let cartCheckoutBtn = document.querySelectorAll(".cart-checkout");
        let zipcodeWrapper = document.querySelectorAll(".pro-check-post")[index];

        cartInputZipcode.addEventListener("input", function () {
            let enteredZipCode = cartInputZipcode.value.trim();
            if (enteredZipCode.length != 6) {
              cartCheckoutBtn.forEach(btn => btn.setAttribute("disabled", "disabled"));
            }
        });

        if (cartInputZipcode && cartCheckZipcodeBtn) {
        
          cartCheckZipcodeBtn.addEventListener("click", function () {
            const enteredZipCode = cartInputZipcode.value.trim();
            const validZipCodePattern = /^\d{6}$/; // Example: 6-digit zip code
            const isValidZipsixCode = validZipCodePattern.test(enteredZipCode);
        
            if (isValidZipsixCode) {
                parseCsv(enteredZipCode, function(result) {
                  if (result) {
                    cartZipcodeError.textContent = "";
                    //cartZipcodeSuccess.textContent = "Estimated Delivery Time: 3-5 Days";
                    cartCheckoutBtn.forEach(btn => btn.removeAttribute("disabled", "disabled"));
                    localStorage.setItem("enteredZipCode", enteredZipCode);
    
                    let customerid = window.ShopifyAnalytics.meta['page']['customerId'];
                    if(customerid == 'undefined' || customerid == '' || customerid == undefined){
                    }else {
                      // var shippingAddress = {};
                      // shippingAddress.zip = enteredZipCode;
                      // shippingAddress.country = 'India';
                      // shippingAddress.province = 'HR';
                      // const params = {
                      //     method: "POST",
                      //     headers: {
                      //         "Content-Type": "application/x-www-form-urlencoded", // Use this content type for form data
                      //     },
                      //     body: new URLSearchParams({ shipping_address: JSON.stringify(shippingAddress) }), // Pass as URL-encoded data
                      // };
                      
                      // // Make the fetch request
                      // fetch("/cart/shipping_rates.json", params)
                      //   .then((response) => {
                      //       if (!response.ok) {
                      //           throw new Error("Network response was not ok");
                      //       }
                      //       return response.json(); // Parse JSON response
                      //   })
                      //   .then((data) => {
                      //        // console.log('success in shipping');
                      //   })
                      //   .catch((error) => {
                      //       // console.log('error in shipping');
                      //   });
                    }
                  } else {
                    //cartZipcodeSuccess.textContent = "";
                    cartZipcodeError.textContent = "Sorry, this pincode is not serviceable!";
                    cartCheckoutBtn.forEach(btn => btn.setAttribute("disabled", "disabled"));
                  }
                });
            } else {
                //cartZipcodeSuccess.textContent = "";
                cartZipcodeError.textContent = "Please enter a valid 6-digit Pincode";
                cartCheckoutBtn.forEach(btn => btn.setAttribute("disabled", "disabled"));
            }
          });
        }

        const savedZipCode = localStorage.getItem("enteredZipCode");
        if (savedZipCode && cartInputZipcode) {
            cartInputZipcode.value = savedZipCode;
            if(cartInputZipcode.value.length > 0){
              zipcodeWrapper.classList.add('rfyes');
            }else{
              zipcodeWrapper.classList.remove('rfyes');
            }
            cartCheckZipcodeBtn.dispatchEvent(new Event("click"));
        }

        let findZipCodeValue = cartInputZipcode.value.trim();
        if(findZipCodeValue == ''){
          //cartZipcodeSuccess.textContent = "";
          cartZipcodeError.textContent = "";
          cartCheckoutBtn.forEach(btn => btn.setAttribute("disabled", "disabled"));
        }
        
      });
    }
  
    function parseCsv(zipcode, callback){
      var jsonFilePath = 'https://cdn.shopify.com/s/files/1/0428/4973/files/Pincodes_-_5th_Dec_1.json?v=1764912974';
      // Use jQuery's getJSON method to fetch the JSON data
      $.getJSON(jsonFilePath, function(data) {
        var targetValue = zipcode;
        var found = false;
        for (var i = 0; i < data.length; i++) {
          if (data[i]["Postal code"] == targetValue) {
            found = true;
            break; // Exit the loop once found
          }
        }
         callback(found);
      });
    }
    /* zipcode validation cart end */

    /* gst validator functions cart start */
    (function () {
        const originalAddEventListener = Element.prototype.addEventListener;
        const originalRemoveEventListener = Element.prototype.removeEventListener;
    
        const listenerRegistry = new WeakMap();
    
        Element.prototype.addEventListener = function (type, listener, options) {
            if (!listenerRegistry.has(this)) {
                listenerRegistry.set(this, []);
            }
            listenerRegistry.get(this).push({ type, listener, options });
            originalAddEventListener.call(this, type, listener, options);
        };
    
        Element.prototype.removeEventListener = function (type, listener, options) {
            if (listenerRegistry.has(this)) {
                const listeners = listenerRegistry.get(this);
                const index = listeners.findIndex(
                    (l) => l.type === type && l.listener === listener && l.options === options
                );
                if (index !== -1) {
                    listeners.splice(index, 1);
                }
            }
            originalRemoveEventListener.call(this, type, listener, options);
        };
    
        Element.prototype.getAllListeners = function () {
            return listenerRegistry.get(this) || [];
        };
    
        Element.prototype.removeAllListeners = function () {
            const listeners = listenerRegistry.get(this);
            if (listeners) {
                listeners.forEach(({ type, listener, options }) => {
                    originalRemoveEventListener.call(this, type, listener, options);
                });
                listenerRegistry.delete(this);
            }
        };
    
        Element.prototype.restoreListeners = function () {
            const listeners = listenerRegistry.get(this);
            if (listeners) {
                listeners.forEach(({ type, listener, options }) => {
                    originalAddEventListener.call(this, type, listener, options);
                });
            }
        };
    })();
  
    let gstCheckbox = document.querySelectorAll(".gst-checkbox");
    if(gstCheckbox){
      gstCheckbox.forEach(function(gstCheckboxBtn) {
        gstCheckboxBtn.addEventListener("click", function () {
          toggleGSTInput(gstCheckboxBtn);
        });
      });
    }
    function toggleGSTInput(gstCheckboxBtnPram) {
        const gstContainer = document.querySelectorAll('.rgst-con');
        if (gstCheckboxBtnPram.checked) {
          gstContainer.forEach(function(gstContainerInd) {
            gstContainerInd.classList.add("gst-opn");
          });
        } else {
          gstContainer.forEach(function(gstContainerInd) {
            gstContainerInd.classList.remove("gst-opn");
          });
        }
    }

    let gstIcn = document.querySelectorAll(".gst-icn");
    if(gstIcn){
      gstIcn.forEach(function(gstIcnBtn) {
        gstIcnBtn.addEventListener("click", function () {
          toggleGstIcon(gstIcnBtn);
        });
      });
    }
    function toggleGstIcon(gstIcnBtnPram) {
      let gstContainerIcn = document.querySelectorAll('.rgst-con');
      if (gstContainerIcn) {
        gstContainerIcn.forEach(function(gstContainerIcnBtn) {
          if(gstContainerIcnBtn.classList.contains('gnt-opn')){
            gstContainerIcnBtn.classList.remove("gnt-opn");
          }else {
            gstContainerIcnBtn.classList.add("gnt-opn");
          }
        });
      }
    }
  
    var isValidStatus = '';
    function initializeCartEvents() {
        var shopifyCheckoutBtn = document.querySelectorAll(".cart-checkout");
        // var existingListeners = shopifyCheckoutBtn.getAllListeners();
        var existingListeners;
        shopifyCheckoutBtn.forEach(function(btn) {
            existingListeners = btn.getAllListeners();
        });
      
        var gstNumInput = document.getElementById("gst-num-input");
        var gstNumError = document.getElementById("gst-num-error");
        var gstNumSuccess = document.getElementById("gst-num-success");
        let delayTimer;
        if(gstNumInput){
          gstNumInput.addEventListener("input", function () {
              clearTimeout(delayTimer);
              delayTimer = setTimeout(function() {
                  gstNumSuccess.textContent = '';
                  gstNumError.textContent = "";
                  let enteredGstNum = gstNumInput.value.trim();
                  if (enteredGstNum.length == 0) {
                    isValidStatus = '';
                    gstNumError.textContent = "";
                    updateCartNote(enteredGstNum, isValidStatus);
                    updateCheckoutBtnsEvents(shopifyCheckoutBtn, existingListeners, 'Drawer')
                  }else if (enteredGstNum.length !== 15) {
                      // console.log('GSTIN must be 15 characters long.');
                      isValidStatus = 'false';
                      gstNumError.textContent = "Please enter a valid GST number";
                      updateCartNote(enteredGstNum, isValidStatus);
                      updateCheckoutBtnsEvents(shopifyCheckoutBtn, existingListeners, 'Drawer')
                  }else {
                      // gstNumError.textContent = "";
                      // console.log('GSTIN 15 verify');
                      let validGstNumPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
                      let isValidGstNum = validGstNumPattern.test(enteredGstNum);
                
                      if (isValidGstNum) {
                          gstNumError.textContent = "";
                          // console.log('true isValidGstNum');
                          //let apiKey = '955bed97ce4ed01529286ac5c5c700aa';
                          let apiKey = 'cb02582aba5c83acf434d6da272dc8a6';
                          let url = `http://sheet.gstincheck.co.in/check/${apiKey}/${enteredGstNum}`;
                          fetch(url)
                          .then(response => response.json())
                          .then(data => {
                            // console.log('GST Response');
                            // console.log(data);
                            if (data.flag == true) {
                              // console.log('GST Flag True');
                              if(data.data.sts == 'Active') {
                                isValidStatus = 'true';
                                gstNumSuccess.textContent = 'GST Verified. Add billing details & address as per your GSTIN at checkout.';
                                updateCartNote(enteredGstNum, isValidStatus);
                              }else {
                                isValidStatus = 'false';
                                gstNumError.textContent = 'GST Suspended';
                                updateCartNote(enteredGstNum, isValidStatus);
                              }
                            } else {
                              // console.log('false GST Flag');
                              isValidStatus = 'false';
                              if(data.message == 'Credit Not Available.'){
                                gstNumError.textContent = 'GST verification temporarily unavailable. You can still proceed to checkout.';
                              }else{
                                gstNumError.textContent = data.message;
                              }
                              updateCartNote(enteredGstNum, isValidStatus);
                            }
                            updateCheckoutBtnsEvents(shopifyCheckoutBtn, existingListeners, 'Drawer')
                          })
                          .catch(error => {
                            console.error('Error fetching GSTIN data:', error);
                            gstNumError.textContent = 'Error validating GST number.';
                          });
                      }else {
                        // console.log('false isValidGstNum');
                        isValidStatus = 'false';
                        gstNumError.textContent = "GSTIN format is invalid";
                        updateCartNote(enteredGstNum, isValidStatus);
                        updateCheckoutBtnsEvents(shopifyCheckoutBtn, existingListeners, 'Drawer')
                      }
                  }
              }, 1000);
          });
        }
    }


    //for cart page
    function initializeCartEventsPage() {
        var shopifyCheckoutBtn = document.querySelectorAll(".cart-checkout");
        // var existingListeners = shopifyCheckoutBtn.getAllListeners();
        var existingListeners;
        shopifyCheckoutBtn.forEach(function(btn) {
            existingListeners = btn.getAllListeners();
        });
      
        var gstNumInputPage = document.getElementById("gst-num-input-page");
        var gstNumErrorPage = document.getElementById("gst-num-error-page");
        var gstNumSuccessPage = document.getElementById("gst-num-success-page");
        let delayTimer;
        if(gstNumInputPage){
          gstNumInputPage.addEventListener("input", function () {
              clearTimeout(delayTimer);
              delayTimer = setTimeout(function() {
                  gstNumSuccessPage.textContent = '';
                  gstNumErrorPage.textContent = "";
                  let enteredGstNum = gstNumInputPage.value.trim();
                  if (enteredGstNum.length == 0) {
                    isValidStatus = '';
                    gstNumErrorPage.textContent = "";
                    updateCartNote(enteredGstNum, isValidStatus);
                    updateCheckoutBtnsEvents(shopifyCheckoutBtn, existingListeners, 'Page')
                  }else if (enteredGstNum.length !== 15) {
                      // console.log('GSTIN must be 15 characters long.');
                      isValidStatus = 'false';
                      gstNumErrorPage.textContent = "Please enter a valid GST number";
                      updateCartNote(enteredGstNum, isValidStatus);
                      updateCheckoutBtnsEvents(shopifyCheckoutBtn, existingListeners, 'Page')
                  }else {
                      // gstNumErrorPage.textContent = "";
                      // console.log('GSTIN 15 verify');
                      let validGstNumPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
                      let isValidGstNum = validGstNumPattern.test(enteredGstNum);
                
                      if (isValidGstNum) {
                          gstNumErrorPage.textContent = "";
                          // console.log('true isValidGstNum');
                          //let apiKey = '955bed97ce4ed01529286ac5c5c700aa';
                          let apiKey = 'cb02582aba5c83acf434d6da272dc8a6';
                          let url = `http://sheet.gstincheck.co.in/check/${apiKey}/${enteredGstNum}`;
                          fetch(url)
                          .then(response => response.json())
                          .then(data => {
                            // console.log('GST Response');
                            // console.log(data);
                            if (data.flag == true) {
                              // console.log('GST Flag True');
                              if(data.data.sts == 'Active') {
                                isValidStatus = 'true';
                                gstNumSuccessPage.textContent = 'GST Verified. Add billing details & address as per your GSTIN at checkout.';
                                updateCartNote(enteredGstNum, isValidStatus);
                              }else {
                                isValidStatus = 'false';
                                gstNumErrorPage.textContent = 'GST Suspended';
                                updateCartNote(enteredGstNum, isValidStatus);
                              }
                            } else {
                              // console.log('false GST Flag');
                              isValidStatus = 'false';
                              if(data.message == 'Credit Not Available.'){
                                gstNumErrorPage.textContent = 'GST verification temporarily unavailable. You can still proceed to checkout.';
                              }else{
                                gstNumErrorPage.textContent = data.message;
                              }
                              updateCartNote(enteredGstNum, isValidStatus);
                            }
                            updateCheckoutBtnsEvents(shopifyCheckoutBtn, existingListeners, 'Page')
                          })
                          .catch(error => {
                            console.error('Error fetching GSTIN data:', error);
                            gstNumErrorPage.textContent = 'Error validating GST number.';
                          });
                      }else {
                        // console.log('false isValidGstNum');
                        isValidStatus = 'false';
                        gstNumErrorPage.textContent = "GSTIN format is invalid";
                        updateCartNote(enteredGstNum, isValidStatus);
                        updateCheckoutBtnsEvents(shopifyCheckoutBtn, existingListeners, 'Page')
                      }
                  }
              }, 1000);
          });
        }
    }
    
    // Function to update cart note
    function updateCartNote(gstIn, gstStatus) {
      // gstIn = gstStatus == 'true' ? gstIn : ''; 
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          note: `customFieldValues: { name: CustomerGSTIN, value: ${gstIn} }`,
          attributes: {
                ["CustomerGSTIN"]: gstIn
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        // console.log('Cart note updated successfully:', data);
      })
      .catch(error => {
        // console.error('Error updating cart note:', error);
      });
    }
  
    // Function to update checkout button event listeners
    function updateCheckoutBtnsEvents(shopifyCheckoutBtn, existingListeners, GstType) {
        // shopifyCheckoutBtn.removeAllListeners();
        shopifyCheckoutBtn.forEach(function(btn) {
            btn.removeAllListeners();
        });
        // shopifyCheckoutBtn.restoreListeners();
        shopifyCheckoutBtn.forEach(function(btn) {
            btn.restoreListeners();
        });
        if (isValidStatus == 'false') {
          // console.log('in pop')
          // Attach your custom handler
          shopifyCheckoutBtn.forEach(function(btn) {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
                showPopup(btn, existingListeners, GstType);
            });
          });
        }
    }
  
    function showPopup(btn, existingListeners, gstType) {
      let clChoutPopup = document.createElement("div");
      clChoutPopup.classList.add("cl-chout-popup");
      let popupBtnId;
      let popupCloseBtn;
      if(gstType == 'Page'){
        popupBtnId = 'continueCheckoutPage';
        popupCloseBtn = 'cl-close-popup-page';
      }else{
        clChoutPopup.classList.add("cl-chout-popup");
        popupBtnId = 'continueCheckout';
        popupCloseBtn = 'cl-close-popup';
      }
      clChoutPopup.innerHTML = `
          <div class="cl-chout-outer">
              <div class="chout-wrapper">
                  <div class="chout-head">
                      <p>Alert!</p>
                      <button class="${popupCloseBtn}">×</button>
                  </div>
                  <div class="chout-content">
                      <p>Your GST number might be suspended. Proceed anyway?</p>
                  </div>
                  <div class="chout-foot">
                      <button id="${popupBtnId}">Yes</button>
                  </div>
              </div>
          </div>`;
      document.body.appendChild(clChoutPopup);
  
      // Handle yes button click
      let continueCheckoutDrawer = document.getElementById("continueCheckout");
      let clClosePopupDrawer = document.querySelector(".cl-close-popup");
      if(continueCheckoutDrawer && clClosePopupDrawer){
        continueCheckoutDrawer.addEventListener("click", () => {
            // console.log("Proceeding with checkout...");
            btn.removeAllListeners();
            btn.restoreListeners();
            btn.click(); 
            clChoutPopup.remove();
        });
  
        // Handle close button
        clClosePopupDrawer.addEventListener("click", () => {
            // console.log("Popup closed.");
            clChoutPopup.remove();
        });
      }

      //for cart page
      let continueCheckoutPage = document.getElementById("continueCheckoutPage");
      let clClosePopupPage = document.querySelector(".cl-close-popup-page");
      if(continueCheckoutPage && clClosePopupPage){
        continueCheckoutPage.addEventListener("click", () => {
            // console.log("Proceeding with checkout...");
            btn.removeAllListeners();
            btn.restoreListeners();
            btn.click(); 
            clChoutPopup.remove();
        });
  
        // Handle close button
        clClosePopupPage.addEventListener("click", () => {
            // console.log("Popup closed.");
            clChoutPopup.remove();
        });
      }
    }
  
  
    // Initial call to bind events when the page loads
    initializeCartEvents();
    initializeCartEventsPage();
    
    // Observe changes in the cart drawer
    const cartContainer = document.querySelector('.previewCart-wrapper');
    if (cartContainer) {
      let cartEventsMutationDebounce;
        const observer = new MutationObserver(() => {
        clearTimeout(cartEventsMutationDebounce);
        cartEventsMutationDebounce = setTimeout(() => {
          initializeCartEvents();
        }, 100);
        });
        observer.observe(cartContainer, { childList: true, subtree: true });
    }
    /* gst validator functions cart end */


    /* show hide content account pg */
    if ($(window).width() > 767) {
      $('.mobile-account').remove();
    }
    if ($(window).width() < 767) {
      $('.desk-account').remove();
    }

    /* zipcode validation cart start */
    /* zipcode validation cart start */
    // const $input1 = $('#CartDrawer #zip-code-input1'); // Input field
    // const $errorDiv1 = $('#CartDrawer #zip-code-error'); // Error div
    // const $successDiv1 = $('#CartDrawer #zip-code-success'); // Error div
    // // Check if the input is empty on page load
    // if ($input1.val().trim() === '') {
    //     $errorDiv1.text('Please enter your zipcode'); // Show error text
    //     $successDiv1.text('');
    // } else {
    //     $errorDiv1.text(''); // Clear error text
    // }

    // const checkInputInterval = setInterval(() => {
    //   const $input2 = $('.cart__page-col #zip-code-input1'); // Input field
    //   const $errorDiv2 = $('.cart__page-col #zip-code-error'); // Error div
    //   const $successDiv2 = $('.cart__page-col #zip-code-success'); // Error div
    //   // Check if the input is empty on page load
    //   if ($input2.length) {
    //     clearInterval(checkInputInterval);  
    //     if ($input2.val().trim() === '') {
    //         $errorDiv2.text('Please enter your zipcode'); // Show error text
    //         $successDiv2.text('');
    //     } else {
    //         $errorDiv2.text(''); // Clear error text
    //     }
    //   }  
    // }, 100);
  
    // $('#CartDrawer #zip-code-input1').on('keyup', function () {
    //     const $parent = $(this).parent(); // Get the parent element
    //     const $errorDiv = $('#CartDrawer #zip-code-error');
    //     const $successDiv = $('#CartDrawer #zip-code-success');
    //     if ($(this).val().trim() !== '') {
    //         // If the input box has a value, add the class 'rfyes' to the parent
    //         $parent.addClass('rfyes');
    //         $errorDiv.text('');
    //     } else {
    //         // If the input box is empty, remove the class 'rfyes' from the parent
    //         $parent.removeClass('rfyes');
    //         $errorDiv.text('Please enter your zipcode');
    //         $successDiv.text('');
    //     }
    // });
  
    // $('.cart__page-col #zip-code-input1').on('keyup', function () {
    //     const $parent = $(this).parent(); // Get the parent element
    //     const $errorDiv = $('.cart__page-col #zip-code-error');
    //     const $successDiv = $('.cart__page-col #zip-code-success'); // Error div
    //     if ($(this).val().trim() !== '') {
    //       // If the input box has a value, add the class 'rfyes' to the parent
    //       $parent.addClass('rfyes');
    //       $errorDiv.text('');
    //     } else {
    //       // If the input box is empty, remove the class 'rfyes' from the parent
    //       $parent.removeClass('rfyes');
    //       $errorDiv.text('Please enter your zipcode');
    //       $successDiv.text('');
    //     }
    // });
    /* zipcode validation cart end */
    /* zipcode validation cart end */

    /* recently viewed script pdp start */
    const isProductTemplate = document.body.classList.contains('template-product');
    const recentlyViewedSection = document.querySelector('[data-rfr-visibility-hydrate="recently-viewed"]');
    const recentlyViewedContainer = document.getElementById('recently-viewed-products');
    const RECENTLY_VIEWED_LIMIT = 8;
    const recentlyViewedProductRequests = new Map();
    let reviewHydrationRaf = null;

    function hydrateReviewBadges(scope) {
      if (!scope || !window.jdgm || typeof window.jdgm.refreshAllWidgets !== 'function') {
        return;
      }

      if (reviewHydrationRaf) {
        cancelAnimationFrame(reviewHydrationRaf);
      }

      reviewHydrationRaf = requestAnimationFrame(() => {
        try {
          window.jdgm.refreshAllWidgets();
        } catch (e) {}
        reviewHydrationRaf = null;
      });
    }

    function parseRecentlyViewedData() {
      try {
        const raw = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
        if (!Array.isArray(raw)) return [];
        return raw;
      } catch (e) {
        return [];
      }
    }

    function getRecentlyViewedProduct(handle) {
      if (!handle) return Promise.resolve(null);

      if (recentlyViewedProductRequests.has(handle)) {
        return recentlyViewedProductRequests.get(handle);
      }

      const request = fetch(`/products/${handle}.js`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        });

      recentlyViewedProductRequests.set(handle, request);
      return request;
    }

    function loadRecentlyViewedProducts() {
      if (!isProductTemplate || !recentlyViewedContainer) return;
      if (recentlyViewedContainer.dataset.rfrLoaded === '1') return;

      const recentlyViewedData = parseRecentlyViewedData();
      if (!recentlyViewedData.length) {
        const retryCount = Number(recentlyViewedContainer.dataset.rfrRetryCount || 0);

        if (retryCount < 4) {
          recentlyViewedContainer.dataset.rfrRetryCount = String(retryCount + 1);
          delete recentlyViewedContainer.dataset.rfrScheduled;

          setTimeout(() => {
            scheduleRecentlyViewedLoad();
          }, 500 * (retryCount + 1));
        }

        return;
      }

      recentlyViewedContainer.dataset.rfrLoaded = '1';
      if (recentlyViewedSection) {
        recentlyViewedSection.classList.add('rfr-is-loading');
      }

      const uniqueProducts = [];
      const seenHandles = new Set();

      for (let i = 0; i < recentlyViewedData.length; i++) {
        const product = recentlyViewedData[i];
        if (!product || !product.handle || seenHandles.has(product.handle)) continue;

        seenHandles.add(product.handle);
        uniqueProducts.push(product);

        if (uniqueProducts.length >= RECENTLY_VIEWED_LIMIT) {
          break;
        }
      }

      if (!uniqueProducts.length) {
        if (recentlyViewedSection) {
          recentlyViewedSection.classList.add('hide');
          recentlyViewedSection.classList.remove('rfr-is-loading');
        }
        return;
      }

      const productRequests = uniqueProducts.map(product => {
        let productHandle = product.handle;
        let productReviewMetafields = product.metafield;

        return getRecentlyViewedProduct(productHandle)
          .then(responseProduct => {
            if (!responseProduct) return null;

            let reguPrice = responseProduct.price;
            let comparePrice = responseProduct.compare_at_price;

            let actualPrice = (reguPrice / 100);
            actualPrice = actualPrice.toLocaleString(window.Shopify.locale, { style: 'currency', currency: Shopify.currency.active, minimumFractionDigits: 0, maximumFractionDigits: 0 });
            let salePrice = (comparePrice / 100);
            salePrice = salePrice.toLocaleString(window.Shopify.locale, { style: 'currency', currency: Shopify.currency.active, minimumFractionDigits: 0, maximumFractionDigits: 0 });

            // Calculate percentage off
            let percentageOff = ((comparePrice - reguPrice) * 100) / comparePrice;
            percentageOff = Math.round(percentageOff);
            let productAvailable = responseProduct.available;
            let checkProductHandle = responseProduct.handle;
            let formBtnHTML = ``;
            let parentClassWrapper = 'pro-avail';

            if (checkProductHandle.includes("with-personalized")) {
              formBtnHTML = `<div>
                            <a href="${checkProductHandle}"><button type="button" name="add" class="button button-ATC is-visible">Customization</button></a>
                          </div>`;
            } else {
              if(productAvailable) {
                formBtnHTML = `<div>
                            <button type="submit" name="add" class="button button-ATC is-visible" data-btn-addToCart>Add to Cart</button>
                          </div>`;
              } else {
                formBtnHTML = `<div>
                            <button name="sold-out" class="button button-ATC is-visible 1234" data-btn-addToCart tabindex="0" disabled>Sold Out</button>
                          </div>`;
                parentClassWrapper = 'pro-notavail';
              }
            }

            let priceHTML = ``;

            if (reguPrice > comparePrice) {
              priceHTML = `
                  <div class="price__regular">
                      <dd class="price__last">
                        <span class="price-item price-item--regular">${actualPrice}</span>
                      </dd>
                  </div>
                `;
            } else {
              priceHTML = `
                <div class="price__sale">
                  <dd class="price__last">
                    <span class="price-item price-item--sale">${actualPrice}</span>
                  </dd>
                  <dd class="price__compare">
                    <span class="price-item price-item--regular">${salePrice}</span>
                  </dd>
                  <div class="desc-per">
                   <dd class="price-item">${percentageOff}%</dd>
                 </div>
                </div>
              `;
            }

            let productHTML = `
                <li>
                  <div class="product-item">
                    <div class="card">
                      <div class="card-product">
                        <div class="card-product__wrapper">
                          <a class="card-link" href="${product.url || responseProduct.url}" title="${responseProduct.title}">
                            <img src="${product.variant_image || responseProduct.images[0]}" alt="${responseProduct.title}" class="motion-reduce">
                          </a>
                        </div>
                      </div>
                      <div class="card-information">
                        <div class="card-information__wrapper text-">
                          <a
                            class="card-title link-underline card-title-ellipsis"
                            href="${product.url || responseProduct.url}"
                            data-product-title="${responseProduct.title}"
                            data-product-url="${product.url || responseProduct.url}"
                          >
                            <span class="text">
                              ${responseProduct.title}
                            </span>
                          </a>
                          <div class="review-wrap">
                            <div class='jdgm-widget jdgm-preview-badge' data-id='${responseProduct.id}' data-template='manual-installation' data-auto-install='false'>
                              ${productReviewMetafields}
                            </div>
                          </div>
                          <div class="card-price">
                            <div class="price  price--on-sale">
                              <dl>
                                ${priceHTML}
                              </dl>
                            </div>`;

            if (reguPrice > 0) {
              productHTML = productHTML + `<div class="card-action rb-demo ${parentClassWrapper}">
                              <form class="variants  rb-varient add-to-cart-form" action="/cart/add" method="post" id="product-form-${responseProduct.id}" data-product-id="${responseProduct.id}">
                                <input type="hidden" name="id" value="${product.variant_id || responseProduct.variants[0].id}">
                                <input type="hidden" name="quantity" value="1" tabindex="-1">
                                ${formBtnHTML}
                              </form>`;
            }

            productHTML = productHTML + `</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
            `;

            recentlyViewedContainer.insertAdjacentHTML('beforeend', productHTML);
            hydrateReviewBadges(recentlyViewedContainer);
            return responseProduct;
          })
          .catch(() => {});
      });

      Promise.allSettled(productRequests).finally(() => {
        if (recentlyViewedSection) {
          recentlyViewedSection.classList.remove('rfr-is-loading');
        }
      });
    }

    function scheduleRecentlyViewedLoad() {
      if (!isProductTemplate || !recentlyViewedContainer) return;
      if (recentlyViewedContainer.dataset.rfrScheduled === '1') return;

      recentlyViewedContainer.dataset.rfrScheduled = '1';

      const startLoad = () => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => loadRecentlyViewedProducts(), { timeout: 2000 });
          return;
        }

        setTimeout(() => loadRecentlyViewedProducts(), 1);
      };

      startLoad();
    }

    if (isProductTemplate && recentlyViewedContainer) {
      const scheduleRecentlyViewedOnFirstScrollFallback = () => {
        const onUserScrollIntent = () => {
          window.removeEventListener('scroll', onUserScrollIntent);
          window.removeEventListener('wheel', onUserScrollIntent);
          window.removeEventListener('touchmove', onUserScrollIntent);

          // Fallback for collapsed/hidden layouts where intersection callbacks never fire.
          scheduleRecentlyViewedLoad();
        };

        window.addEventListener('scroll', onUserScrollIntent, { once: true, passive: true });
        window.addEventListener('wheel', onUserScrollIntent, { once: true, passive: true });
        window.addEventListener('touchmove', onUserScrollIntent, { once: true, passive: true });
      };

      scheduleRecentlyViewedOnFirstScrollFallback();

      if ('IntersectionObserver' in window) {
        const recentlyViewedTarget = recentlyViewedSection || recentlyViewedContainer;
        const recentlyViewedObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            scheduleRecentlyViewedLoad();
          });
        }, { rootMargin: '0px 0px' });

        recentlyViewedObserver.observe(recentlyViewedTarget);
      } else {
        scheduleRecentlyViewedLoad();
      }
    }
    // Function to initialize Slick slider
    // function initializeSlick() {
    //   $(".recently-pro-carousel").slick({
    //     mobileFirst: true,
    //     adaptiveHeight: true,
    //     vertical: false,
    //     infinite: true,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     dots: false,
    //     responsive: [
    //       {
    //         breakpoint: 1599,
    //         settings: {
    //           arrows: true,
    //           dots: false,
    //           slidesToShow: 5,
    //           slidesToScroll: 2,
    //         },
    //       },
    //       {
    //         breakpoint: 1024,
    //         settings: {
    //           arrows: true,
    //           dots: false,
    //           slidesToShow: 5,
    //           slidesToScroll: 2,
    //         },
    //       },
    //       {
    //         breakpoint: 991,
    //         settings: {
    //           arrows: true,
    //           dots: false,
    //           slidesToShow: 4,
    //           slidesToScroll: 2,
    //         },
    //       },
    //       {
    //         breakpoint: 767,
    //         settings: {
    //           arrows: true,
    //           dots: false,
    //           slidesToShow: 3,
    //           slidesToScroll: 2,
    //         },
    //       },
    //       {
    //         breakpoint: 320,
    //         settings: {
    //           arrows: true,
    //           dots: false,
    //           slidesToShow: 2,
    //           slidesToScroll: 2,
    //         },
    //       },
    //     ],
    //   });
    // }
    /* recently viewed script pdp end */

    /* Two rows product slick slider */
    // function initTwoRowSlider() {
    //   if ($(window).width() >= 768) {
    //     if (!$('.two-rows-products-carousel').hasClass('slick-initialized')) { 
    //       $(".two-rows-products-carousel").slick({
    //         mobileFirst: true,
    //         adaptiveHeight: true,
    //         vertical: false,
    //         slidesToShow: 4,      // Show 2 items per row
    //         slidesToScroll: 2,    // Scroll 2 items at a time
    //         rows: 2,              // Display 2 rows in a single slide
    //         dots: false,           // Show dots for navigation
    //         arrows: true,        // Hide arrows for mobile
    //         autoplay: false,       // Enable auto-play
    //         infinite: false,
    //         responsive: [
    //           {
    //             breakpoint: 991,
    //             settings: {
    //               arrows: true,
    //               dots: false,
    //               slidesToShow: 4,
    //               slidesToScroll: 2,
    //               rows: 2,
    //             },
    //           },
    //           {
    //             breakpoint: 767,
    //             settings: {
    //               arrows: true,
    //               dots: true,
    //               slidesToShow: 3,
    //               slidesToScroll: 2,
    //             },
    //           },
    //         ],
    //       });
    //     }
    //   }else{
    //     if ($('.two-rows-products-carousel').hasClass('slick-initialized')) {
    //       $('.two-rows-products-carousel').slick('unslick');
    //     }
    //   }
    // }

    /* testimonials slick slider mom-unstoppable */
    // let testiMomItems = $(".mom_testi_item");
    // if (testiMomItems.length > 1) {
    //   $(".mom_testimonials").slick({
    //     mobileFirst: true,
    //     adaptiveHeight: true,
    //     vertical: false,
    //     infinite: false,
    //     arrows: true,
    //     dots: true,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     responsive: [
    //       {
    //         breakpoint: 767,
    //         settings: {
    //           arrows: false,
    //           dots: true,
    //           slidesToShow: 1,
    //           slidesToScroll: 1,
    //         },
    //       },
    //       {
    //         breakpoint: 320,
    //         settings: {
    //           arrows: false,
    //           dots: true,
    //           slidesToShow: 1,
    //           slidesToScroll: 1,
    //         },
    //       },
    //     ],
    //   });
    // }


    // function momUnstoppableUsbSlider() {
    //   if ($(window).width() <= 768) {
    //     if (!$('.pusp-bxs').hasClass('slick-initialized')) {
    //       $('.pusp-bxs').slick({
    //         adaptiveHeight: true,
    //         vertical: false,
    //         slidesToShow: 1, 
    //         slidesToScroll: 1,
    //         dots: true,
    //         arrows: false,
    //         autoplay: false,
    //         infinite: false,
    //         responsive: [
    //           {
    //             breakpoint: 768,  // Apply Slick slider only for screens <= 768px
    //             settings: {
    //               slidesToShow: 1.2,
    //               slidesToScroll: 1
    //             }
    //           }
    //         ]
    //       });
    //     }
    //   } else {
    //     if ($('.pusp-bxs').hasClass('slick-initialized')) {
    //       $('.pusp-bxs').slick('unslick');
    //     }
    //   }
    // }


    /* knowledge base category two rows slick slider */
    // function knowBaseCatSlider() {
    //   if ($(window).width() <= 768) {
    //     var swiper = new Swiper(".mySwiper", {
    //       slidesPerView: 'auto',
    //       spaceBetween: 10,
    //       grid: {
    //         rows: 2,
    //         fill: 'row' // Fill rows first
    //       }
    //     });
    //   }
    // }
  


  

  
});





window.onload = function() {
    /* get review number pdp */
    const reviewSpan = document.querySelector('.pdp-review .re');
    if (reviewSpan) {
      const reviewMatch = reviewSpan.textContent.match(/\d+/);
      if (reviewMatch) {
        reviewSpan.textContent = reviewMatch[0];
      }
    }

    // setTimeout(function () {
    //   let referenceElement = document.querySelector('.evm_wiser_heading');
    //   let newParagraph = document.createElement('div');
    //   newParagraph.classList.add("rfe-subttl");
    //   newParagraph.innerHTML = 'Buy all 3 &amp; get an <span>extra 5% off</span>';
    //   if (referenceElement) {
    //     referenceElement.insertAdjacentElement('afterend', newParagraph);
    //   }
    // }, 1000);

    // Run only on product page
    if (document.body.classList.contains('template-product')) {
      function insertOfferMessage() {
        const referenceElement = document.querySelector('.evm_wiser_heading');
        if (referenceElement && !document.querySelector('.rfe-subttl')) {
          const newParagraph = document.createElement('div');
          newParagraph.classList.add("rfe-subttl");
          newParagraph.innerHTML = 'Buy all 3 &amp; get an <span>extra 5% off</span>';
          referenceElement.insertAdjacentElement('afterend', newParagraph);
          return true;
        }
        return !!document.querySelector('.rfe-subttl');
      }

      if (!insertOfferMessage()) {
        if ('MutationObserver' in window) {
          const offerObserver = new MutationObserver(() => {
            if (insertOfferMessage()) {
              offerObserver.disconnect();
            }
          });

          offerObserver.observe(document.body, { childList: true, subtree: true });
          setTimeout(() => offerObserver.disconnect(), 5000);
        } else {
          setTimeout(insertOfferMessage, 700);
        }
      }
    }
    
};





document.addEventListener("DOMContentLoaded", function () {
    /* customize product atc disabled popup */
    setTimeout(function () {
      let findPtcBtn = document.querySelector('.ptc_button');
      let cartPaymentBtn = document.querySelector('[data-add-to-cart]');
      if(findPtcBtn) {
        if (cartPaymentBtn && cartPaymentBtn.hasAttribute('disabled')) {
          findPtcBtn.classList.add('disabled');
          findPtcBtn.disabled = true;
          findPtcBtn.textContent = cartPaymentBtn.textContent;
        }
        document.querySelector(".ptc_button").addEventListener("click", function () {
            setTimeout(function () {
                const popup = document.querySelector(".pplr_crop-modal");
                if (popup) {
                    const addToCartButton = popup.querySelector(".p_a_t_c");
                    const inputFields = popup.querySelectorAll("textarea, input[type='text'], input[type='number']");
                    addToCartButton.disabled = true;
                    addToCartButton.classList.add("disabled");
                    inputFields.forEach((field) => {
                        field.addEventListener("input", function () {
                            let allFilled = Array.from(inputFields).some((input) => input.value.trim() !== "");
                            addToCartButton.disabled = !allFilled;
                            if (allFilled) {
                                addToCartButton.classList.remove("disabled");
                            }else{
                                addToCartButton.classList.add("disabled");
                            }
                        });
                    });
                }
            }, 1000);
        });
      }
    }, 1000);
});


jQuery(document).ready(function ($) {
    $('.knowsec .knsubcat .trft a').attr('href', 'javascript:void(0)');

    jQuery('.knowsec .knsubcat .trft a').click(function () {
        if(!$('.knowsec').hasClass("optabs")){
            $('.knowsec').addClass("optabs")
        }else{
            $('.knowsec').removeClass("optabs")
        }  
    });

    // jQuery('.kncates .kncat').click(function (e) {
    //   if (jQuery(this).hasClass("oplins")) {
    //     jQuery(this).removeClass("oplins");
    //   } else {
    //     jQuery('.kncates .kncat').removeClass("oplins");
    //     jQuery(this).addClass("oplins");
    //   }
    // });

    jQuery('.kncates .kncat').click(function (e) {
      //console.log('fof scroll');
      //var headerHeight = $('header').outerHeight();
      var headerHeight = 100;
      if ($(window).width() <= 768) {
        //console.log('fof scroll2');
        $('html, body').animate({
            scrollTop: $('.knowsec .kncondata').offset().top - headerHeight
        }, 1000)
      }  
    });

});




document.addEventListener('cart:updated', updateCartDrawerTitle);
document.addEventListener('cart:open', updateCartDrawerTitle);
document.addEventListener('ajaxProduct:added', updateCartDrawerTitle);

document.addEventListener('click', function (event) {
  if (event.target && event.target.closest('.js-drawer-open-cart')) {
    updateCartDrawerTitle();
  }
}, true);




let cartTitleRequest = null;
let cartTitleLastCount = null;
let cartTitleLastFetchedAt = 0;
const CART_TITLE_CACHE_TTL = 1500;

function applyCartDrawerTitle(titleEl, itemCount) {
  if (itemCount > 0) {
    const itemText = itemCount === 1 ? 'Item' : 'Items';
    titleEl.textContent = `(${itemCount}) ${itemText} in your cart`;
  } else {
    titleEl.textContent = 'Cart';
  }
}

function updateCartDrawerTitle() {
  const titleEl = document.querySelector('.cart-drawer-title');
  if (!titleEl) return;

  const now = Date.now();
  if (cartTitleLastCount !== null && (now - cartTitleLastFetchedAt) < CART_TITLE_CACHE_TTL) {
    applyCartDrawerTitle(titleEl, cartTitleLastCount);
    return Promise.resolve();
  }

  if (cartTitleRequest) {
    return cartTitleRequest;
  }

  cartTitleRequest = fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      cartTitleLastCount = cart.item_count;
      cartTitleLastFetchedAt = Date.now();
      applyCartDrawerTitle(titleEl, cart.item_count);
    })
    .catch(() => {})
    .finally(() => {
      cartTitleRequest = null;
    });

  return cartTitleRequest;
}
function initRfrInfiniteSliders(scope = document) {
  const sliders = scope.querySelectorAll('.rfr-slider');

  sliders.forEach(slider => {
    const track = slider.querySelector('.rfr-slider__track');
    const prevBtn = slider.querySelector('.rfr-slider__btn--prev');
    const nextBtn = slider.querySelector('.rfr-slider__btn--next');

    // Prevent double initialization
    if (!track || !prevBtn || !nextBtn || track.dataset.rfrInit === '1') return;
    track.dataset.rfrInit = '1';

    const originalItems = Array.from(track.children);
    const itemCount = originalItems.length;
    if (itemCount === 0) return;

    // --- 1. Clone Logic (Infinite) ---
    // Clone items: Add all items to the end AND all items to the beginning
    originalItems.forEach(item => {
      const cloneLast = item.cloneNode(true);
      cloneLast.classList.add('rfr-clone');
      track.appendChild(cloneLast);
    });

    // Clone in reverse for the beginning
    [...originalItems].reverse().forEach(item => {
      const cloneFirst = item.cloneNode(true);
      cloneFirst.classList.add('rfr-clone');
      track.insertBefore(cloneFirst, track.firstChild);
    });

    // Helper: Calculate single item width including gap
    const getScrollStep = () => {
      const item = track.querySelector('.rfr-slide-item') || track.children[0];
      const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      return item.offsetWidth + gap;
    };

    // --- 2. Mobile Dots Setup ---
    const mobileStep = parseInt(slider.getAttribute('data-mobile-step')) || 1;
    const dotsContainer = document.createElement('div');
    dotsContainer.classList.add('rfr-slider__dots');
    
    // Calculate number of dots needed
    const dotCount = Math.ceil(itemCount / mobileStep);
    
    // Create Dots
    for (let i = 0; i < dotCount; i++) {
      const dot = document.createElement('button');
      dot.classList.add('rfr-slider__dot');
      dot.setAttribute('aria-label', `Go to slide group ${i + 1}`);
      dot.dataset.index = i;
      
      // Dot Click Event
      dot.addEventListener('click', () => {
        const itemWidth = getScrollStep();
        // Calculate position: (Clone Offset) + (Dot Index * Mobile Step * Width)
        const targetIndex = itemCount + (i * mobileStep); 
        
        track.style.scrollBehavior = 'smooth';
        track.scrollLeft = targetIndex * itemWidth;
      });
      
      dotsContainer.appendChild(dot);
    }
    slider.appendChild(dotsContainer);
    const dots = dotsContainer.querySelectorAll('.rfr-slider__dot');

    // Helper: Update Active Dot
    const updateActiveDot = () => {
      const itemWidth = getScrollStep();
      const currentScroll = track.scrollLeft;
      
      // Calculate which "virtual" index we are at
      // We subtract itemCount because we started with a set of clones
      let virtualIndex = Math.round(currentScroll / itemWidth) - itemCount;

      // Handle the wrapping logic for the dots calculation
      // If we are in the left clones (negative virtualIndex), normalize it
      if (virtualIndex < 0) {
        virtualIndex = itemCount + virtualIndex;
      }
      // If we are in the right clones, normalize it
      if (virtualIndex >= itemCount) {
        virtualIndex = virtualIndex - itemCount;
      }

      // Determine active dot based on step size
      const activeDotIndex = Math.floor(virtualIndex / mobileStep);

      dots.forEach((dot, index) => {
        if (index === activeDotIndex) {
          dot.classList.add('rfr-active');
        } else {
          dot.classList.remove('rfr-active');
        }
      });
    };

    // --- 3. Initial Position ---
    const initialJump = () => {
      const step = getScrollStep();
      track.style.scrollBehavior = 'auto';
      // Start at the first "real" item (after the first set of clones)
      track.scrollLeft = step * itemCount;
      updateActiveDot();
    };
    
    setTimeout(initialJump, 50);

    // --- 4. Infinite Loop Logic ---
    const reCenter = () => {
      const step = getScrollStep();
      const x = track.scrollLeft;
      const contentWidth = step * itemCount;

      // Scroll far right -> Jump back to middle
      if (x >= contentWidth * 2) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = x - contentWidth;
      } 
      // Scroll far left -> Jump forward to middle
      else if (x <= 10) { // Tolerance for 0
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = x + contentWidth;
      }
    };

    // --- 5. Event Listeners ---
    nextBtn.addEventListener('click', () => {
      track.style.scrollBehavior = 'smooth';
      track.scrollLeft += getScrollStep();
    });

    prevBtn.addEventListener('click', () => {
      track.style.scrollBehavior = 'smooth';
      track.scrollLeft -= getScrollStep();
    });

    track.addEventListener('scroll', () => {
      // 1. Update dots immediately for responsiveness
      updateActiveDot();

      // 2. Handle Infinite Loop Debounce
      clearTimeout(track.loopTimeout);
      track.loopTimeout = setTimeout(() => {
        reCenter();
        // Update dots again after recenter to be sure
        updateActiveDot();
      }, 100); 
    });

    window.addEventListener('resize', initialJump);
  });
}

document.addEventListener('DOMContentLoaded', () => initRfrInfiniteSliders());
document.addEventListener('shopify:section:load', (e) => initRfrInfiniteSliders(e.target));


function initVoiceSearch() {

  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SpeechRecognition) return;

  document.querySelectorAll(".voice-search-btn").forEach((btn) => {

    if (btn.dataset.voiceInitialized) return;
    btn.dataset.voiceInitialized = "true";

    const form = btn.closest("form");
    if (!form) return;

    const input = form.querySelector('input[type="search"]');
    if (!input) return;

    const recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = navigator.language || "en-US";

    btn.addEventListener("click", () => {
      recognition.start();
      btn.classList.add("listening");
    });

    recognition.onresult = function(event) {
      input.value = event.results[0][0].transcript;
      btn.classList.remove("listening");

      setTimeout(() => {
        form.submit();
      }, 500);
    };

    recognition.onerror = function() {
      btn.classList.remove("listening");
    };

    recognition.onend = function() {
      btn.classList.remove("listening");
    };

  });
}

document.addEventListener("DOMContentLoaded", initVoiceSearch);
document.addEventListener("shopify:section:load", initVoiceSearch);



(function() {

  const originalFetch = window.fetch;

  window.fetch = function(input, init) {

    let requestUrl = '';

    if (typeof input === 'string') {
      requestUrl = input;
    } else if (input && input.url) {
      requestUrl = input.url;
    }

    if (!requestUrl || requestUrl.indexOf('/cart/') === -1) {
      return originalFetch.apply(this, arguments);
    }

    return originalFetch.apply(this, arguments).then(response => {

      /* ==========================
         HANDLE PRODUCT ADD
      ========================== */
      if (requestUrl.includes('/cart/add')) {

        response.clone().json().then(addedItem => {

          const installVariantId = addedItem.properties?._installation_variant_id;
          if (!installVariantId) return;

          // Prevent infinite loop
          if (addedItem.properties && addedItem.properties._linked_to) return;

          // 🔥 CHECK CHECKBOX STATE HERE
          const checkbox = document.querySelector('#installation-checkbox');
          if (!checkbox || !checkbox.checked) return;

          originalFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: installVariantId,
              quantity: addedItem.quantity,
              properties: {
                _linked_to: addedItem.key
              }
            })
          }).then(() => {
            refreshCartDrawer();
          });

        }).catch(() => {});
      }

      /* ==========================
         HANDLE REMOVE / QTY CHANGE
      ========================== */
      if (requestUrl.includes('/cart/change') || requestUrl.includes('/cart/update')) {

        setTimeout(() => {
          removeOrphanInstallations();
        }, 300);

      }

      return response;
    });

  };


  function removeOrphanInstallations() {

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        cart.items.forEach(item => {

          if (item.properties && item.properties._linked_to) {

            const parentExists = cart.items.find(
              parent => parent.key === item.properties._linked_to
            );

            if (!parentExists) {

              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 0
                })
              }).then(() => {
                refreshCartDrawer();
              });

            }
          }
        });
      });
  }


  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }

})();